import React from 'react';

type StopIconProps = {
  fill?: string;
};

const StopIcon: React.FC<StopIconProps> = ({
  fill = 'var(--primary-color)',
}) => {
  return (
    <svg
      width="34"
      height="34"
      viewBox="0 0 34 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.8175 3.40967C9.31585 3.40967 3.22754 9.49798 3.22754 16.9997C3.22754 24.5013 9.31585 30.5896 16.8175 30.5896C24.3192 30.5896 30.4075 24.5013 30.4075 16.9997C30.4075 9.49798 24.3192 3.40967 16.8175 3.40967ZM12.5 12.5H21.1349V21.1349H12.5V12.5Z"
        fill={fill}
      />
    </svg>
  );
};

export default StopIcon;
